<template>
  <div class="container">
    <router-view></router-view>
  </div>
  
</template>

<script>
	export default {
		methods: {
			alertDisplay() {
			  this.$swal({
			    title: '<h1 class="popup-title">Its time to turn <span class="blue-popup">off</span><br> to turn <span class="blue-popup">in</span></h1>',
			    html:
			        '<p class="popup-copy">Do you find yourself constantly reaching for your phone in any silent moments or when there is space in your day?</p><p class="popup-copy">Like many, our devices have become our addiction.</p><p class="popup-copy"><strong>Get a free PDF workbook and start your own digital detox.</strong></p>' ,
			    confirmButtonText: '<a href="https://jackie-serviss.mykajabi.com/detoxoptin" target="_blank">DOWNLOAD FREE PDF</a>'
			  });
			}
		},
		created: function () {
		  setTimeout(() => this.alertDisplay(), 1500);
		}
	}
</script>

<style>
	@import "https://use.typekit.net/ysf0tri.css";
	body {
		margin: 0 !important;
	}



	.swal2-popup {
	  width: 50% !important;
	  padding: 50px;
	  background-image: url("assets/img/popup-bg.jpg");
	  background-size: cover;
	  background-repeat: no-repeat;
	  background-position: center;
	}

	#swal2-content {
		padding: 15px;
		background-color: rgba(0, 0, 0, 0.45);
		border-radius: 10px;
	}
	#swal2-content p.popup-copy {
		color: #fff !important;
		font-family: 'Brandon Grotesque', sans-serif;
	}

	h2#swal2-title h1 {
		font-size: 64px;
		text-align: center;
		color: #f0bed8; 
		font-family: adobe-caslon-pro, serif;
		font-weight: 700;
		font-style: italic;
		line-height: 60px;
		margin: 0;
	}

	button.swal2-styled { 
		padding: 0 !important;
		transition: all 0.125s linear;
	}
	button.swal2-styled:hover {
		background-image: none !important;
		background-color: #5d5f92 !important;

	}
	button.swal2-styled a {
		color: inherit;
		text-decoration: none;
		padding: 15px 40px;
		display: block;
	}

	h1 span.blue-popup {
		color: #2e3192;
	}

	button.swal2-confirm {
		background-color: #7577b7 !important;
	}
	button.swal2-confirm:focus {
		box-shadow: none !important;
	}

	@media ( max-width: 775px ) {
		.swal2-popup {
		    width: 95% !important;
		    padding: 26px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue